import { connect } from 'react-redux';
import { redirect } from 'redux-first-router';

import SignupForm from './SignupForm';
import { actions as Pages } from '@pages/names';
import { udpateUserStats, searchUserByUsername } from '@service/user';
import { INVITE_LOCALSTORAGE_KEY } from '../../actions/ranking';
import { markPendingOnboardings } from '../../constants/onboardings';

export const updateUser = (changes) => (dispatch, getState) => {
  let { jwToken, user } = getState();

  dispatch({ type: 'USER_SAVING', payload: true });
  return udpateUserStats(jwToken, user._id, changes)
    .then((res) => {
      dispatch({ type: 'AUTH_UPDATE_USER', payload: changes });
      markPendingOnboardings(user?._id);
      dispatch({ type: 'USER_SAVING', payload: false });
      dispatch({ type: 'AUTH_SET_PROFILE_SETUP' });
      const previousInviteCode = localStorage.getItem(INVITE_LOCALSTORAGE_KEY);
      if (previousInviteCode) {
        dispatch(
          redirect({
            type: Pages.RankingInvite,
            payload: { inviteCode: previousInviteCode },
          })
        );
        localStorage.removeItem(INVITE_LOCALSTORAGE_KEY);
      } else {
        dispatch(redirect({ type: Pages.Home }));
      }
    })
    .catch((err) => {
      dispatch({
        type: 'AUTH_SET_PROFILE_ERRORS',
        payload: err?.response?.data,
      });
      dispatch({ type: 'USER_SAVING', payload: false });
    });
};

export const checkUsernameAvailable = (username) => (dispatch, getState) => {
  let { jwToken } = getState();
  return searchUserByUsername(jwToken, username)
    .then((res) => {
      const unavailable = res.data.total === 1;
      if (unavailable) {
        dispatch({
          type: 'AUTH_SET_PROFILE_ERRORS',
          payload: { username: true },
        });
        return false;
      }
      dispatch({ type: 'AUTH_CLEAR_PROFILE_USERNAME_ERROR' });
      return true;
    })
    .catch((error) => {
      dispatch({
        type: 'AUTH_SET_PROFILE_ERRORS',
        payload: { username: true },
      });
      return false;
    });
};

export const mapStateToProps = ({ user, savingUser, profileStatus }) => ({
  usernameError: !!(profileStatus.errors && profileStatus.errors.username),
  dniError: !!(
    profileStatus?.errors?.dni || profileStatus?.errors?.errors?.dni
  ),
  saving: savingUser,
});

export const mapDispatchToProps = (dispatch) => ({
  onSubmit: (changes) => dispatch(updateUser(changes)),
  checkUsername: (username) => dispatch(checkUsernameAvailable(username)),
  clearUsernameUnavailableError: () =>
    dispatch({ type: 'AUTH_CLEAR_PROFILE_USERNAME_ERROR' }),
  clearDniError: () => dispatch({ type: 'AUTH_CLEAR_PROFILE_DNI_ERROR' }),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignupForm);
